<template>
    <div class="context">
        <!--文本描述-->
        <div v-if="showText" class="text main">
            <div class="box" @click="edit">
                <div class="des">
                    {{form.description}}
                </div>
                <div class="right_btn" v-if="!disabled">
                    <div class="icon" @click.stop="delDes">
                        <span class="iconfont icon-shanchu1"></span>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="form main">
            <div class="box">
                <el-form :model="form"
                         :rules="rules"
                         ref="form"
                         size="small"
                         label-width="1px">
                    <el-form-item prop="description">
                        <el-input class="width_all_100"
                                  placeholder="请输入文本描述"
                                  v-model="form.description"></el-input>
                    </el-form-item>
                    <el-form-item align="right">
                        <el-button @click="cancel">取消</el-button>
                        <el-button @click="submit" type="primary">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="left_question_type">文本描述</div>
    </div>
</template>

<script>
    import {clone} from "@/global/utils";
    import {mapState, mapMutations} from "vuex"
    export default {
        name: "text_v",
        data() {
            return {
                form: {},
                showText: false,
                rules: {
                    description: [{required: true, message: '请输入文本描述', trigger: 'blue'}],
                },
            }
        },
        props: [
            'des',
            'num',
            'disabled'
        ],
        computed: {
            ...mapState('questionData', {
                edit_ques: 'edit_ques'
            })
        },
        watch: {
            des() {
                if (this.des.question_id) {
                    this.form = clone(this.des);
                }
            },
        },
        mounted() {
            this.form = clone(this.des);
            this.form.order = this.num;
            this.form.number = this.num;
            this.showText = !!this.form.description;
        },
        methods: {
            ...mapMutations('questionData', {
                setEditQues: 'setEditQues'
            }),
            cancel() {
                this.form = clone(this.des);
                this.form.order = this.num;
                this.form.number = this.num;
                this.setEditQues(false);
                if (this.form.description) {
                    this.showText = true;
                } else {
                    this.$emit('changeQues')
                }
            },
            submit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let params = {
                            ...this.form
                        };
                        this.httpPost('/survey/question/save', params).then(res => {
                            this.$emit('changeQues');
                            this.form = res.data;
                            this.showText = true;
                            this.setEditQues(false);
                        })
                    }
                })
            },
            edit() {
                console.log('edit----');
                if (this.disabled) return;
                if (this.edit_ques) {
                    this.$message.warning('已有题目处于编辑状态');
                    return
                }
                this.showText = false;
                this.setEditQues(true)
            },
            delDes() {
                let params = {
                    question_id: this.form.question_id
                };
                this.httpPost('/survey/question/delete', params).then(res => {
                    this.$emit('changeQues');
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        text-align: left;
        font-size: .875rem;
        line-height: 35px;
        position: relative;
        .main {
            border-top: 1px solid #fff;
            border-bottom: 1px solid #fff;
            padding: 5px 0;
            .box {
                margin: 0 15%;
            }
        }
        .text {
            background: #fff;
            position: relative;
            z-index: 1;
            &:hover {
                background-color: #fafafa;
                border-top: 1px solid #e0e0e0;
                border-bottom: 1px solid #e0e0e0;
                .box {
                    .right_btn {
                        display: flex;
                    }
                }
            }
            .box {
                .right_btn {
                    display: none;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    right: 0;
                    z-index: 2;
                    width: 60px;
                    border-left: 1px solid #e0e0e0;
                    background: #F5F5F5;

                    flex-flow: column;
                    .icon {
                        flex: 1;
                        width: 100%;
                        border-bottom: 1px solid #e0e0e0;
                        position: relative;
                        .iconfont {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 1.5rem;
                        }
                    }

                }
            }
        }
        .form {
            background-color: #fafafa;
            border-top: 1px solid #e0e0e0;
            border-bottom: 1px solid #e0e0e0;
        }

        .left_question_type {
            position: absolute;
            top: 10px;
            left: 20px;
            font-size: .75rem;
            color: #606266;
            z-index: 3;
        }
    }
</style>